import React from 'react';
export default function InputLabel({ content }) {
  return (
    <label className="block text-base font-semibold mb-1">{content}</label>
  );
}
